import dayjs from "dayjs";
import QuestionMarkTooltip from "components/QuestionMarkTooltip";

const WeekHeader = ({ date, holidays = [] }) => {
  const holiday = holidays.find(
    (item) => item.date === dayjs(date).format("YYYY-MM-DD")
  );

  const is_holiday = !!holiday?.name;

  return (
    <div className={`calendar-header ${is_holiday ? "holiday" : ""}`}>
      <p className="calendar-header__day">{dayjs(date).format("DD.MM")}</p>
      <p className="calendar-header__week_day">{dayjs(date).format("dddd")}</p>
      {is_holiday && (
        <div className="calendar-header__holiday">
          <QuestionMarkTooltip text={holiday.name} />
        </div>
      )}
    </div>
  );
};

export default WeekHeader;
